import { useMemo, useState } from 'react';
import type { FunctionRecord } from '../types';

interface PackageFunctionsListProps {
  functions: FunctionRecord[];
  selectedIds: string[];
  onChange: (ids: string[]) => void;
}

export function PackageFunctionsList({ functions, selectedIds, onChange }: PackageFunctionsListProps) {
  const [search, setSearch] = useState('');

  const filteredFunctions = useMemo(() => {
    if (!search) return functions;
    const keyword = search.toLowerCase();
    return functions.filter(
      (fn) =>
        fn.name.toLowerCase().includes(keyword) ||
        fn.code.toLowerCase().includes(keyword) ||
        (fn.description ?? '').toLowerCase().includes(keyword)
    );
  }, [functions, search]);

  const toggle = (id: string) => {
    if (selectedIds.includes(id)) {
      onChange(selectedIds.filter((item) => item !== id));
    } else {
      onChange([...selectedIds, id]);
    }
  };

  return (
    <div className="package-functions-list">
      <div className="pfl-header">
        <div className="pfl-heading">
          <p className="title">Danh sách chức năng</p>
          <span className="count-badge">
            {selectedIds.length} đã chọn
          </span>
        </div>
        <label className="pfl-search">
          <i className="ti ti-search" />
          <input
            type="search"
            placeholder="Tìm kiếm chức năng…"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </label>
      </div>
      <div className="pfl-body">
        {filteredFunctions.length === 0 ? (
          <div className="empty-state">
            <i className="ti ti-inbox" />
            <p>Không có chức năng phù hợp với tìm kiếm của bạn.</p>
          </div>
        ) : (
          <ul className="pfl-list">
            {filteredFunctions.map((fn) => {
              const checked = selectedIds.includes(fn.id);
              return (
                <li key={fn.id} className={`pfl-item ${checked ? 'is-selected' : ''}`}>
                  <label className="checkbox-wrapper" htmlFor={`fn-${fn.id}`}>
                    <input
                      id={`fn-${fn.id}`}
                      type="checkbox"
                      checked={checked}
                      onChange={() => toggle(fn.id)}
                    />
                    <span className="custom-checkbox" />
                  </label>
                  <div className="item-content">
                    <div className="item-head">
                      <div className="item-title">
                        <span className="name">{fn.name}</span>
                        <span className="code-badge">{fn.code}</span>
                      </div>
                      {/* Ẩn module_id (ID của collection modules) */}
                      {/* <span className="module-chip">{fn.module_id ?? 'Không rõ module'}</span> */}
                    </div>
                    {fn.description && <p className="item-desc">{fn.description}</p>}
                    {/* NOTE: fn.id không được hiển thị trong UI, chỉ dùng cho logic (key, checkbox id, toggle) */}
                  </div>
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </div>
  );
}


